import { Component } from 'utils/jsx'
import { writable, derived } from 'utils/state'

import cuid from 'cuid'
import classnames from 'classnames'
import { debounce } from 'debounce'
import { roundTo } from 'missing-math'

import Button from 'components/dom/Button'

export default class Range extends Component {
  beforeRender (props) {
    this.handleInput = props.debounce
      ? debounce(this.handleInput.bind(this), props.debounce)
      : this.handleInput.bind(this)

    this.state = {
      id: props.id || cuid(),
      min: writable(props.min),
      max: writable(props.max),
      defaultValue: writable(props.defaultValue || props.value || props['store-value'].current),
      value: props['store-value'] ? props['store-value'] : writable(props.value),
      disabled: props['store-disabled'] ? props['store-disabled'] : writable(props.disabled),
      hidden: props['store-hidden'] ? props['store-hidden'] : writable(props.hidden)
    }

    this.state.isMax = derived([this.state.value, this.state.max], () => this.state.value.current >= this.state.max.current)
    this.state.isMin = derived([this.state.value, this.state.min], () => this.state.value.current <= this.state.min.current)
  }

  template (props) {
    return (
      <div
        class={classnames('range', props.class, { 'has-ghost': props.showGhost })}
        store-class-is-disabled={this.state.disabled}
        store-class-is-hidden={this.state.hidden}
        store-class-is-max={this.state.isMax}
        store-class-is-min={this.state.isMin}
      >
        {props.icon && <i class={`fa fa-${props.icon}`} />}
        {props.children.length > 0 && <label for={this.state.id}>{props.children}</label>}
        <div class='range__input'>
          <input
            type='range'
            id={this.state.id}
            title={props.title}
            ref={this.ref('input')}
            event-input={this.handleInput}
            event-dblclick={() => this.state.value.set(this.state.defaultValue.current)}
            store-value={this.state.value}
            step={props.step}
          />
          <input
            type='range'
            class='range__ghost'
            ref={this.ref('ghost')}
            store-value={this.state.defaultValue}
            step={props.step}
            disabled
          />
        </div>
        {props.fineTuneButtons && [
          <Button
            icon='minus'
            class='range__fine-tune-button'
            store-disabled={this.state.isMin}
            event-click={() => this.state.value.update(v => Math.max(this.state.min.get(), v - props.step))}
          />,
          <Button
            icon='plus'
            class='range__fine-tune-button'
            store-disabled={this.state.isMax}
            event-click={() => this.state.value.update(v => Math.min(this.state.max.get(), v + props.step))}
          />
        ]}
      </div>
    )
  }

  afterRender () {
    this.state.min.subscribe(this.handleMin.bind(this))
    this.state.max.subscribe(this.handleMax.bind(this))

    this.handleMin()
    this.handleMax()
  }

  handleMin (min = this.state.min.get()) {
    this.refs.input.setAttribute('min', roundTo(min, this.props.step))
    this.refs.ghost.setAttribute('min', roundTo(min, this.props.step))
    if (min <= +this.refs.input.value) return
    this.state.value.current = +this.refs.input.value
  }

  handleMax (max = this.state.max.get()) {
    this.refs.input.setAttribute('max', roundTo(max, this.props.step))
    this.refs.ghost.setAttribute('max', roundTo(max, this.props.step))
    if (max >= +this.refs.input.value) return
    this.state.value.current = +this.refs.input.value
  }

  handleInput (e) {
    if (this.props['event-input']) this.props['event-input'](e)
    this.state.value.set(+this.refs.input.value)
  }
}



// WEBPACK FOOTER //
// ./src/components/dom/Range.js